import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { BaseComponent } from '../../../shared/components/base/base.component';
import { DealerSettingName } from '../../interfaces/IDealerSettings';
import { AlternateTranslationService } from '../../services/alternate-translation.service';
import { PermissionsService } from '../../services/permissions.service';
import { NewBroadcastChannelComponent } from '../new-chat-dialog/new-broadcast-channel/new-broadcast-channel.component';
import { NewDirectChatComponent } from '../new-chat-dialog/new-direct-chat/new-direct-chat.component';
import { NewGroupChatComponent } from '../new-chat-dialog/new-group-chat/new-group-chat.component';
import { NewPhoneChatComponent } from '../new-chat-dialog/new-phone-chat/new-phone-chat.component';

@Component({
  selector: 'ngx-profile-actions',
  templateUrl: './profile-actions.component.html',
  styleUrls: ['./profile-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProfileActionsComponent extends BaseComponent {
  private dialog = inject(MatDialog);
  permissionService = inject(PermissionsService);
  alternateTranslationService = inject(AlternateTranslationService);

  @Output() settingsEvent = new EventEmitter<boolean>();

  isMasterStore = signal(this.permissionService.checkDealerSettingByValue(DealerSettingName.truConnectGroupName, null));

  constructor() {
    super();
  }

  openNewBroadcast(): void {
    this.dialog.open(NewBroadcastChannelComponent, {
      panelClass: 'dialog-container-custom',
      width: '600px',
    });
  }

  openNewDirectChat(): void {
    this.dialog.open(NewDirectChatComponent, {
      panelClass: 'dialog-container-custom',
      width: '25vw',
    });
  }

  openNewGroupChat(): void {
    this.dialog.open(NewGroupChatComponent, {
      panelClass: 'dialog-container-custom',
      width: '25vw',
    });
  }

  goSettings(): void {
    this.settingsEvent.emit(true);
  }

  createPhoneChannel(): void {
    this.dialog.open(NewPhoneChatComponent, {
      panelClass: 'dialog-container-custom',
      width: '25vw',
    });
  }
}
